
<div class=" mt-4">
    <div class="row">
        <div class="col-md-8 offset-md-2">
            <div class="card-1">
                <h3 class="setup-h3 mb-3">Finish your store setup...</h3>
                <p>Sellers who add more than 25 products are likely to get more orders. Add all your products to your e-commerce store now.</p>
                <div class="stepsContainer mt-3">


                    <div class="stepCircle" [ngStyle]="{'background': stepOne ? 'green':'lightgrey'}">
                        1
                    </div>
                
                    <div class="stepConectorPiece" [ngStyle]="{'background': stepOne ? 'green':'lightgrey'}"></div>
                
                    <div class="stepCircle" [ngStyle]="{'background': stepTwo ? 'green' : 'lightgrey'}">
                        2
                    </div>
                
                    <div class="stepConectorPiece" [ngStyle]="{'background': stepTwo ? 'green' : 'lightgrey'}"></div>
                
                
                    <div class="stepCircle" [ngStyle]="{'background': stepThree ? 'green':'lightgrey'}">
                        3
                    </div>
                    <div class="stepConectorPiece" [ngStyle]="{'background': stepThree ? 'green' : 'lightgrey'}"></div>
                
                
                    <div class="stepCircle" [ngStyle]="{'background': stepFour ? 'green':'lightgrey'}">
                       4
                    </div>
                    <div class="stepConectorPiece" [ngStyle]="{'background': stepFour ? 'green' : 'lightgrey'}"></div>
                
                
                    <div class="stepCircle" [ngStyle]="{'background': stepFive ? 'green':'lightgrey'}">
                       5
                    </div>
                    
                </div>
                
                <div class="" *ngIf="personalInfoComplete">
                     <div class="text-center">
                         <h4>Add your Business Info</h4>
                         <p>Fill your business info details</p>
                         <div class="mt-3">
                            <button class="btn dash-btns"  (click)="personalInfoSubmit()">Add</button>
                         </div>
                     </div> 
                </div>
                
                <div class="" *ngIf="addressComplete">
                    <div class="text-center">
                        <h4>Add your Tax Fee</h4>
                        <p>Fill your Tax Fee  details</p>
                        <div class="mt-3">
                           <button class="btn dash-btns"  (click)="addressSubmit()">Add</button>
                        </div>
                    </div> 
                     
                </div>
                
                
                <div class="" *ngIf="creditCardComplete">
                    <div class="text-center">
                        <h4>Add your Categories</h4>
                        <p>Start adding Categories to your online store now!</p>
                        <div class="mt-3">
                           <button class="btn dash-btns"  (click)="creditCardSubmit()">Add</button>
                        </div>
                    </div> 
                     
                </div>
                <div class="" *ngIf="addproducts">
                    <div class="text-center">
                        <h4>Add your Items</h4>
                        <p>Start adding Items to your online store now!</p>
                        <div class="mt-3">
                           <button class="btn dash-btns"  (click)="productsubmit()">Add</button>
                        </div>
                    </div> 
                     
                </div>
                <div class="" *ngIf="additems">
                    <div class="text-center">
                        <h4>Add your Items</h4>
                        <p>Start adding Items to your online store now!</p>
                        <div class="mt-3">
                           <button class="btn dash-btns"  (click)="itemsubmit()">Add</button>
                        </div>
                    </div> 
                     
                </div>
                <div class="" *ngIf="selectorder">
                    <div class="text-center">
                        <h4>Create Order</h4>
                        <p>Create your own order for your Website</p>
                        <div class="mt-3">
                           <button class="btn dash-btns"  (click)="Ordercreate()">Add</button>
                        </div>
                    </div> 
                     
                </div>
                
                <div class="thankYou" *ngIf="completedOrder">Thank You!<br>Your Order is Complete</div>
            </div>
        </div>
    </div>
</div>
